<template>
  <div class="CampusRank1">
    <div class="titlegaga">月消费(万元)</div>
    <div id="MonthCustom"></div>
  </div>
</template>

<script>
import G2 from '@antv/g2';

export default {
  name: 'MonthCustom',
  props: ['data'],
  data() {
    return {
      chart: null,
      max: -1,
      min: -1,
    };
  },
  methods: {
    initChart() {
      var screenWidth = window.outerWidth;
      this.max = -1;
      this.min = -1;
      this.data.forEach(item => {
        if (this.max == -1) {
          this.max = item.money;
        } else {
          if (item.money > this.max) {
            this.max = item.money;
          }
        }
        if (this.min == -1) {
          this.min = item.money;
        } else {
          if (item.money < this.min) {
            this.min = item.money;
          }
        }
      });
      if (!this.chart) {
        this.chart = new G2.Chart({
          container: 'MonthCustom',
          forceFit: true,
          height: window.outerHeight / 4,
          padding: ['4%', '2%', '10%', '10%'],
        });
        this.chart.source(this.data);
        this.chart.scale('money', {
          alias: '月消费(万元)',
        });
        this.chart.legend(false);
        this.chart.axis('month', {
          label: {
            textStyle: {
              fill: '#fff',
              fontSize:window.outerWidth/1960*16
            },
          },
          tickLine: {
            alignWithLabel: false,
            length: 0,
          },
        });
        this.chart.axis('money',{
          label: {
            textStyle: {
              fontSize: screenWidth/1936*16,
              fill: '#fff'
            }
          },
        })
        // this.chart.axis('money', false);
        this.chart.tooltip({
          share: true,
        });
        let that = this;
        this.chart
          .interval()
          .position('month*money')
          .opacity(1)
          // .label('value', {
          //   useHtml: true,
          //   htmlTemplate: function htmlTemplate(text, item) {
          //     var a = item.point;
          //     if (a.money == that.max || a.money == that.min) {
          //       return (
          //         '<span class="g2-label-item"><p class="g2-label-item-value">' +
          //         a.money +
          //         '</p></div>'
          //       );
          //     } else {
          //       return '';
          //     }
          //   },
          // });
        this.chart.interval().position('month*money');
        this.chart.interval().position('month*money').color('#4CD4FA');
        this.chart.render();
      } else {
        this.chart.changeData(this.data);
      }
    },
  },
};
</script>

<style lang="scss">
.CampusRank {
  height: 100%;
  width: 100%;
}
</style>
